import React from 'react';

/** @registry Turns PDF bytes (a Blob, e.g. FileResponse.data) into a stable object URL for <PdfViewer>; revokes the previous URL when the blob changes and on unmount. */
export const usePdfBlobUrl = (blob: Blob | null | undefined): string | null => {
  const [url, setUrl] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (!blob) {
      setUrl(null);
      return;
    }

    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [blob]);

  return url;
};
